import { render, staticRenderFns } from "./MatchOptionsIndividual.vue?vue&type=template&id=54e3526c&scoped=true&"
import script from "./MatchOptionsIndividual.vue?vue&type=script&lang=js&"
export * from "./MatchOptionsIndividual.vue?vue&type=script&lang=js&"
import style0 from "./MatchOptionsIndividual.vue?vue&type=style&index=0&id=54e3526c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e3526c",
  null
  
)

export default component.exports